import type { ActionConfig } from "@smartsuite/automation-engine-api";
import type {
  ActionGroupCandidate,
  AutomationCandidate,
} from "../../types/candidate";
import { collectActionsDeep } from "../../stores/automation/utils/action-group-walk";

// NOTE: mutable function
export const clearAutomationInputs = (
  automation: AutomationCandidate,
): void => {
  automation.actions.forEach((action) => {
    clearActionInputs(action);
  });
  automation.actionGroups.forEach((group) => {
    clearActionGroupInputs(group);
  });
};

const clearActionGroupInputs = (group: ActionGroupCandidate): void => {
  collectActionsDeep([group]).forEach(clearActionInputs);
};

const clearActionInputs = (action: ActionConfig): void => {
  action.inputs = action.inputs.filter(
    (input) => input.value?.values?.length !== 0,
  );
};
